var map = {
	"./map/map.module": "./src/app/pages/map/map.module.ts",
	"./order-management/order-management.module": "./src/app/pages/order-management/order-management.module.ts",
	"./pages/pages.module": "./src/app/pages/pages.module.ts",
	"./user-management/user-management.module": "./src/app/pages/user-management/user-management.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;